import { EFinancingProgram } from '@if/core/types'
import {
  DecisionTreeInfoDto,
  DecisionTreeVersionInfoDto,
} from '@src/data/api/tree-simulation/tree-simulation-api'
import { SelectValueListItem } from '@src/data/types/SelectValueListItem'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useFinancingProgramItems = (): SelectValueListItem[] => {
  const { t } = useTranslation()

  return useMemo(() => {
    const financingPrograms = [
      EFinancingProgram.Personal,
      EFinancingProgram.B2c,
      // EFinancingProgram.CreditRsla, Ne fonctionne pas car le workflow d'analyse fait des trucs étranges
      // EFinancingProgram.IfXpress - à tester lorsque le programme aura été correctement implanté]
    ]

    return financingPrograms.map((program) => ({
      value: program,
      label: t(`EFinancingProgram.${program}`, { ns: 'enum', defaultValue: program }),
    }))
  }, [t])
}

export const useDecisionTreeItems = (trees: DecisionTreeInfoDto[]): SelectValueListItem[] => {
  return useMemo(() => trees.map((tree) => ({ value: tree.id, label: tree.name })), [trees])
}

export const useDecisionTreeItemsWithNone = (trees: DecisionTreeInfoDto[]): SelectValueListItem[] => {
  const { t } = useTranslation()
  const treeItems = useDecisionTreeItems(trees)

  return useMemo(
    () => [{ value: '', label: t('treeSimulation.form.none') }, ...treeItems],
    [treeItems, t],
  )
}

export const useDecisionTreeVersionItems = (versions: DecisionTreeVersionInfoDto[]): SelectValueListItem[] => {
  const { t } = useTranslation()

  return useMemo(
    () =>
      versions.map((v) => ({
        value: v.id,
        label: `${t('treeSimulation.form.version', { version: v.version, defaultValue: `v${v.version}` })}${v.comment ? ` — ${v.comment}` : ''}`,
      })),
    [versions, t],
  )
}

export const useDecisionTreeVersionItemsWithNone = (versions: DecisionTreeVersionInfoDto[]): SelectValueListItem[] => {
  const { t } = useTranslation()
  const versionItems = useDecisionTreeVersionItems(versions)

  return useMemo(
    () => [{ value: '', label: t('treeSimulation.form.none') }, ...versionItems],
    [versionItems, t],
  )
}
